import { useEffect, useState } from 'react';
import { useNCZIContext } from '../Services/NCZIContext';
import useNCZICommands from './useNCZICommands';
import apiClient from '../../../Services/ApiClient';
import { FinishedCommand } from '../Commands/Command';
import { NCZIEhrExtractEnvelope } from '../Interfaces/ncziTypes';
import { GetPatientVaccinationList, GetPatientVaccinationListParams } from '../Commands/GetPatientVaccinationList';
import {
	ElectronicVaccinationFilterValues
} from '../Components/ElectronicVaccination/Filter/ElectronicVaccinationFilter';

export default function useNCZIElectronicVaccination() {
	const {
		patientVaccinationData, setPatientVaccinationData, setPatientVaccinationPage, patientIdentifier
	} = useNCZIContext();

	const { commands, execute } = useNCZICommands();

	const [listVaccinationCommandId, setListVaccinationCommandId] = useState<string | undefined>(undefined);
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(undefined);

	const fetchPatientElectronicVaccinationData = async (
		params: GetPatientVaccinationListParams,
	) => {
		const command = await obtainPatientElectronicVaccinationListData(params);
		setPatientVaccinationData(null);
		return command;
	};

	useEffect(() => {
		if (listVaccinationCommandId && !patientVaccinationData) {
			const command = commands[listVaccinationCommandId];
			if (command && command.state === 'done') {
				const finishedCommand = command as FinishedCommand;
				if (finishedCommand.result) {
					setPatientVaccinationData(finishedCommand.result as NCZIEhrExtractEnvelope);
				}
			}
		}
	}, [commands, listVaccinationCommandId]);

	const obtainPatientElectronicVaccinationListData = async (
		params: GetPatientVaccinationListParams,
	) => {
		const commandGetPatientVaccinationList = GetPatientVaccinationList(params);

		if (params?.page) {
			setPatientVaccinationPage(params.page);
		}
		const result = await execute(commandGetPatientVaccinationList);
		if (!('error' in result && result.error)) {
			setListVaccinationCommandId(result.id);
		}

		return result;
	};

	const handleLoadPatientVaccinationData = async (page: number = 1, filterValues?: ElectronicVaccinationFilterValues) => {
		if (patientIdentifier) {
			const command = await fetchPatientElectronicVaccinationData({
				patientCode: patientIdentifier,
				page,
				reactionDateFrom: filterValues?.reactionDateFrom?.format('YYYY-MM-DD'),
				reactionDateTo: filterValues?.reactionDateTo?.format('YYYY-MM-DD'),
				executionDateFrom: filterValues?.executionDateFrom?.format('YYYY-MM-DD'),
				executionDateTo: filterValues?.executionDateTo?.format('YYYY-MM-DD'),
				writeDateFrom: filterValues?.writeDateFrom?.format('YYYY-MM-DD'),
				writeDateTo: filterValues?.writeDateTo?.format('YYYY-MM-DD'),
				includeCancelled: filterValues?.includeCancelled,
				onlyOwnRecords: filterValues?.onlyOwnRecords,
				onlyVaccinationWithReaction: filterValues?.onlyVaccinationWithReaction,
				vaccinationKind: filterValues?.vaccinationKind,
				vaccinationType: filterValues?.vaccinationType,
			});
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleFakeLoadPatientVaccinationData = async () => {
		const { data: response } = await apiClient.get(
			'/nczi/message/bfc3b090-489b-490b-b4d1-ca1ebe91aaee/response',
		);
		setPatientVaccinationPage(1);
		setPatientVaccinationData(response.data);
	};

	return {
		handleLoadPatientVaccinationData,
		handleFakeLoadPatientVaccinationData,
		loadingCommandId
	};
}
